import React, { CSSProperties, FC, useState } from 'react'
import type { WidgetCardProps } from './widget-card.d'
import styles from './widget-card.module.scss'

export const WidgetCard: FC<WidgetCardProps> = ({
  children,
  disabled,
  textColor = '#000000',
  hoverTextColor = '#000000',
  borderColor = '#ABB9C1',
  hoverBorderColor = '#37A4F2',
  backgroundColor = '#FFFFFF',
  hoverBackgroundColor = '#F4FFFD',
  disabledTextColor = '#8797A1',
  disabledBorderColor = '#ABB9C1',
  disabledBackgroundColor = '#F6F9FB',
  cursor = 'pointer',
  position,
  onClick,
}) => {
  const [isHover, setIsHover] = useState(false)

  const getCardBorder = () => {
    if (position === 'first') {
      return '0.5px 0.5px 0.25px 0.5px'
    } else if (position === 'middle') {
      return '0.25px 0.5px 0.25px 0.5px'
    } else if (position === 'last') {
      return '0.25px 0.5px 0.5px 0.5px'
    } else {
      return '0.5px'
    }
  }
  const getCardBorderRadius = () => {
    if (position === 'first') {
      return '10px 10px 0px 0px'
    } else if (position === 'middle') {
      return '0px 0px 0px 0px'
    } else if (position === 'last') {
      return '0px 0px 10px 10px'
    } else {
      return '10px'
    }
  }
  const getBoxShadow = () => {
    if (position === 'first') {
      return '0 0 4px 0 rgba(0, 0, 0, 0.10)'
    } else if (position === 'middle') {
      return '0 0 4px 0 rgba(0, 0, 0, 0.10)'
    } else if (position === 'last') {
      return '0 2px 4px 0 rgba(0, 0, 0, 0.10)'
    } else {
      return '0 2px 4px 0 rgba(0, 0, 0, 0.10)'
    }
  }
  const customClass: CSSProperties = {
    background: disabled
      ? disabledBackgroundColor
      : isHover
      ? hoverBackgroundColor
      : backgroundColor,
    color: disabled ? disabledTextColor : isHover ? hoverTextColor : textColor,
    borderStyle: 'solid',
    borderWidth: `${getCardBorder()}`,
    borderColor: disabled
      ? disabledBorderColor
      : isHover
      ? hoverBorderColor
      : borderColor,
    cursor: cursor,
    borderRadius: getCardBorderRadius(),
    boxShadow: getBoxShadow(),
  }

  const handleMouseEnter = () => {
    setIsHover(true)
  }
  const handleMouseLeave = () => {
    setIsHover(false)
  }

  return (
    <button
      className={styles['root']}
      style={customClass}
      disabled={disabled}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
